import type { Maybe } from '@adornis/base/utilTypes.js';
import { Entity, Field } from '@adornis/baseql/decorators.js';
import type { PartialEntityData } from '@adornis/baseql/entities/types.js';
import { MeetingLink } from '@adornis/bh-video-conferencing/entities/MeetingLink.js';
import { ValidationError } from '@adornis/validation/errors/ValidationError.js';
import { TimeSlot } from '../datetime/time-slot.js';

export interface IAppointment {
  start: Date;
  end: Date;
  location: Maybe<string>;
  isNonBlocking: Maybe<boolean>;
}

export const appointmentStartTimeValidation = ({ key, target, value }) => {
  if (!value) return;
  if (target.end <= value)
    throw new ValidationError('Start-Zeit muss vor End-Zeit liegen', {
      key,
      target,
      translationKey: 'appointment_start_needs_to_be_smaller_than_end',
    });
};

export const appointmentEndTimeValidation = ({ key, target, value }) => {
  if (!value) return;
  if (value <= target.start)
    throw new ValidationError('End-Zeit muss hinter Start-Zeit liegen', {
      key,
      target,
      translationKey: 'appointment_start_needs_to_be_smaller_than_end',
    });
};

@Entity()
export class Appointment extends TimeSlot {
  public static override _class = 'Appointment';

  constructor(doc: PartialEntityData<Appointment> | { start: Date; end: Date }) {
    super(doc);
  }

  @Field(type => String)
  location: Maybe<string>;

  @Field(type => String)
  name: Maybe<string>;

  @Field(type => MeetingLink)
  meetingLink: Maybe<MeetingLink>;

  override toString() {
    return `am ${this.start?.toLocaleString('de-DE', { timeZone: 'Europe/Berlin', dateStyle: 'medium', timeStyle: 'short' })} bis ${this.end?.toLocaleString('de-DE', { timeZone: 'Europe/Berlin', dateStyle: 'medium', timeStyle: 'short' })} ${
      this.location ? `in ${this.location}` : ''
    }`;
  }
}
